import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import TableHeaderDisplay from "../../../components/Periscope/ItemAvailability/TableHeaderDisplay";
import { store } from "../../../store/configureStore";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
	getBrandDetail,
	getBrandDetailViaName,
	getPlatformDetailViaName,
	getRenderToolTipItemAvailability
} from "../../../helpers/periscope";
import { ActionTypes } from "../../../actions/_types";
import { lS, trackEvent } from "../../../atlas-utils";
import ReactTable from "../../../components/Periscope/NewTable/ReactTable";
import EntityHead from "../../../components/Periscope/NewTable/EntityHead";
import { CATALOGUE_PLATFORMS_LOGO } from "../../../client-config";
import EntityCard from "../../../components/Periscope/NewTable/EntityCard";
import EntityCell from "../../../components/Periscope/NewTable/EntityCell";

const LocationTable = ({
	tableData,
	platformCount,
	defaultPlatforms,
	periscopeItemAvailabilityData,
	periscopeItemAvailabilityState,
	handlePagination,
	handlePageSize,
	selectedBrand,
	configItems,
	refreshBtn,
	periscopeCountryWiseSupportedPlatforms,
	login
}) => {
	const data = periscopeItemAvailabilityData?.location?.data?.objects?.data;
	const brands = configItems?.brands?.items;
	const loading = periscopeItemAvailabilityData?.location?.loading;
	const error = periscopeItemAvailabilityData?.location?.error;
	const dataCount = periscopeItemAvailabilityState?.count || 0;
	const limit = periscopeItemAvailabilityState?.limit;
	const offset = periscopeItemAvailabilityState?.offset;
	const country = (login?.loggedInbizDetail?.country || lS.get("auth")?.biz?.country).toLowerCase();
	const isMultibrandEnabled = login?.loggedInbizDetail?.isMultibrandEnabled;
	const bizPlatforms = configItems?.bizPlatforms?.items.filter((platform) => {
		if (platform.platformName == "All Platforms") {
			return true;
		}
		return (periscopeCountryWiseSupportedPlatforms?.[country] ||
			lS.get("periscopeCountryWisePlatforms")?.[country])?.[platform.platformName.toLowerCase()]?.enabled;
	});

	const dispatchSortFunction = (sort) => {
		if (sort == null) {
			store.dispatch({
				type: ActionTypes.ITEM_AVAILABILITY_INITIAL_SORT
			});
		} else {
			store.dispatch({
				type: ActionTypes.ITEM_AVAILABILITY_STATE_FILTERS,
				payload: sort
			});
		}
	};

	const sortThePlatform = (column) => {
		let order = null;
		const currentSort = periscopeItemAvailabilityState?.sort;
		store.dispatch({
			type: ActionTypes.ITEM_AVAILABILITY_STATE_FILTERS,
			payload: { offset: 0 }
		});
		if (currentSort?.field === column) {
			order = currentSort.order === "asc" ? "desc" : currentSort.order === "desc" ? null : "asc";
		} else {
			order = "asc";
		}
		const sort = order ? { sort: { field: column, order } } : null;
		dispatchSortFunction(sort);
	};

	const history = useHistory();

	const redirectToDetailedView = (data, rest) => {
		const propsValue = rest?.propsValue;
		const cell = rest?.totalRow;
		if (!cell) {
			return;
		}
		const total = propsValue?.total;
		if (total !== 0) {
			trackEvent("periscope_detail_view_clicked", { module: "item_availability" });
			const platformName = cell.column.id;
			const locationValues = cell.row.allCells[0].value;
			let g = cell.row.allCells[1];
			let brandName = "";
			if (g.column.id == "brand") {
				const brandColumn = cell.row.allCells[1].value;
				brandName = getBrandDetailViaName(brandColumn?.name, brands);
			}
			store.dispatch({
				type: ActionTypes.SPECIFIC_ITEM_AVAILABILITY_STATE_LOCATION_FILTERS,
				payload: {
					currentFilters: { platform_names: [cell.column.id] },
					appliedFilters: { platform_names: [cell.column.id] },
					initialCall: false
				}
			});
			store.dispatch({
				type: ActionTypes.SPECIFIC_ITEM_AVAILABILITY_LOCATION_INITIAL_STATE
			});
			const platformId = getPlatformDetailViaName(platformName, bizPlatforms).id;
			const brandDetails =
				cell?.row?.allCells[1].column.id == "brand"
					? getBrandDetail(cell?.row?.allCells[1]?.value?.id, brands)
					: getBrandDetail(selectedBrand?.id, brands);
			let queryParam = `?location_id=${encodeURIComponent(locationValues?.id)}&location=${encodeURIComponent(locationValues?.name)}&platform_id=${encodeURIComponent(platformId)}&platform=${encodeURIComponent(platformName)}${isMultibrandEnabled ? `&brand_id=${encodeURIComponent(brandDetails?.id)}&brand=${encodeURIComponent(brandDetails?.name)}` : ``}`;
			history.push(
				`/periscope/item-availability/location/${encodeURIComponent(locationValues?.name)}${queryParam}`,
				{ locationValues }
			);
		}
	};

	const rowspanned = ["location"];
	const columnsData = useMemo(() => {
		return [...tableData].map((col) => {
			if (selectedBrand?.id !== "all") {
				return null;
			}
			return {
				id: col,
				render: () => {
					return (
						<EntityHead
							title={col}
							{...(col !== "location" &&
								col !== "brand" && {
									imgSrc:
										getPlatformDetailViaName(col, bizPlatforms)?.image ||
										CATALOGUE_PLATFORMS_LOGO[col],
									sort: col !== "location" && col !== "brand",
									handleSortClick: sortThePlatform,
									sortOrder: periscopeItemAvailabilityState.sort?.order,
									sortedField: periscopeItemAvailabilityState.sort?.field
								})}
						/>
					);
				}
			};
		});
	}, [tableData, selectedBrand]);

	const duplicateValues = useMemo(() => {
		let valuesPattern = [null, null, null, undefined, undefined, undefined];
		let indexInPattern = 0;
		return Array.from({ length: 9 }).map((_) => {
			let obj = {};
			let currColumns = tableData;
			if (selectedBrand?.id !== "all") {
				currColumns = currColumns.filter((col) => col !== "brand");
			}

			currColumns.forEach((key) => {
				obj[key] = valuesPattern[indexInPattern];
			});
			indexInPattern = (indexInPattern + 1) % valuesPattern.length;
			return obj;
		});
	}, [tableData, error, selectedBrand]);
	const renderCellToolTip = useCallback(
		getRenderToolTipItemAvailability({
			unitText: "items",
			showHint: true
		}),
		[]
	);

	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);
	const view = queryParams?.get("view");

	const newColumns = useMemo(() => {
		return Object.keys(loading || error ? duplicateValues?.[0] || {} : data?.[0] || {})
			.map((obj) => {
				if (tableData.includes(obj)) {
					return {
						accessor: obj,
						enableRowSpan: rowspanned.includes(obj),

						Cell: (props) => {
							if (props?.column?.id === "location") {
								return (
									<EntityCard
										classes={`${selectedBrand?.id !== "all" ? "multi-brand" : ""}`}
										loading={loading}
										currCell={props.column.id}
										error={error}
										title={props?.value?.name}
										{...(selectedBrand?.id !== "all"
											? { ratingText: true, star: true, rating: props?.value?.rating }
											: {})}
									/>
								);
							} else if (props?.column?.id === "brand") {
								const currentBrand = props?.value?.id && getBrandDetail(props?.value?.id, brands);

								return (
									<EntityCard
										loading={loading}
										error={error}
										ratingText
										displayIcon
										rating={props?.value?.rating}
										star
										brandText={currentBrand?.name}
										imgSrc={currentBrand?.image}
										currCell={props.column.id}
										title={props?.value?.name}
										iconColor={currentBrand?.color}
									/>
								);
							} else {
								const totalLocations = props?.value?.total;
								const onlineLocations = props?.value?.available;
								const stringValue =
									totalLocations > 0 && onlineLocations == 0
										? "false-state"
										: totalLocations == onlineLocations &&
											  totalLocations !== 0 &&
											  onlineLocations !== 0
											? "true-state"
											: totalLocations == 0
												? "empty-state"
												: "custom-cell";
								const onlineItemPercentage =
									stringValue == "custom-cell" &&
									((props.value.available / props.value.total) * 100).toFixed(2).replace(/\.00$/, "");

								return (
									<EntityCell
										loading={loading}
										error={error}
										styles={{ width: platformCount }}
										classes={`${
											stringValue == "true-state"
												? "true-state cursor-pointer"
												: stringValue == "false-state" || stringValue == "custom-cell"
													? "false-state cursor-pointer"
													: "empty-state"
										}
										`}
										value={
											stringValue == "true-state"
												? true
												: stringValue == "false-state"
													? false
													: null
										}
										customToolTip={true}
										renderToolTip={renderCellToolTip}
										handleCellClick={redirectToDetailedView}
										customContent={stringValue == "custom-cell"}
										propsValue={props?.value}
										totalRow={props}
									>
										<div className="custom-percentage">{onlineItemPercentage}%</div>
									</EntityCell>
								);
							}
						}
					};
				}
				return null;
			})
			.filter(Boolean);
	}, [data, loading, tableData, brands, platformCount, error, duplicateValues, selectedBrand?.id, view]);

	const renderTableHead = () => {
		return (
			<>
				<tr className="tr-first">
					<td rowSpan={2} className={`location-td  ${selectedBrand?.id !== "all" ? "brand-selected" : ""} `}>
						Location
					</td>
					{selectedBrand?.id !== "all" ? null : (
						<td rowSpan={2} className="brand-td">
							Brand
						</td>
					)}

					<td colSpan={platformCount.count} className="items-at-location">
						Items at location
					</td>
				</tr>
				<tr>
					{tableData.map((table, index) => {
						if (
							(selectedBrand?.id !== "all" && table == "brand") ||
							table == "location" ||
							table == "brand"
						) {
							return null;
						}
						return (
							<td
								key={index}
								style={{ width: ` ${platformCount.percent}`, cursor: "pointer" }}
								onClick={() => sortThePlatform(table)}
							>
								<TableHeaderDisplay index={index} table={table} textRight={true} />
							</td>
						);
					})}
				</tr>
			</>
		);
	};

	return (
		<div>
			{defaultPlatforms && defaultPlatforms.length > 0 && (
				<>
					<ReactTable
						loading={loading}
						error={error}
						customTableHead
						renderTableHead={renderTableHead}
						rowspanned={rowspanned}
						classes={`item-availability-location ${selectedBrand?.id !== "all" ? "brand-selected" : ""}`}
						data={loading || error ? duplicateValues : data}
						columns={newColumns}
						colsArray={columnsData}
						thStyles={{
							cols: ["location", "brand"],
							styles: {
								width: platformCount,
								textAlign: "end"
							}
						}}
						limit={limit}
						offset={offset}
						goToPage={handlePagination}
						setPageSize={handlePageSize}
						count={dataCount}
						fetchData={refreshBtn}
					/>
				</>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	configItems: state.configItems,
	login: state.login,
	periscopeItemAvailabilityData: state.periscopeItemAvailabilityData,
	periscopeCountryWiseSupportedPlatforms: state.periscopeCountryWiseSupportedPlatforms,
	periscopeItemAvailabilityState: state.periscopeItemAvailabilityState
});

export default connect(mapStateToProps)(LocationTable);
